module.exports = __webpack_public_path__ + "static/sunil-be7f6ec75035e947a91dfed383f93f20.jpg";